import { ListSubheader, Menu } from '@mui/material';
import bind from 'memoize-bind';
import React, { Component, Fragment } from 'react';

import { ListItemText, MenuItem } from '@sumologic/yama-ds-components';

import { ClickLink } from 'shared/components/internal/ClickLink';

import { Source } from '../types';
import css from './FilterSource.module.scss';

interface FilterSourceProps {
  sources: Source[];
  sourceLabel: string;
  activeSource: string;
  autofocus: boolean;
  onSourceChange: (source: string) => void;
}

interface FilterSourceState {
  anchorEl: HTMLElement | null;
}

export class FilterSource extends Component<
  FilterSourceProps,
  FilterSourceState
> {
  state: FilterSourceState = {
    anchorEl: null,
  };

  componentDidMount() {
    const { activeSource, autofocus } = this.props;

    if (!activeSource && autofocus) {
      this.setState({
        anchorEl: null,
      });
    }
  }

  getSourceLabel() {
    const { sources, activeSource } = this.props;

    let buttonLabel = '';
    if (activeSource && sources) {
      const source = sources.find((s) => s.prop === activeSource);
      if (source) {
        buttonLabel = source.label;
      }
    }

    return buttonLabel;
  }

  onSourceMenuClick(
    e: React.MouseEvent<HTMLDivElement | HTMLAnchorElement, MouseEvent>
  ) {
    this.setState({
      anchorEl: e.currentTarget,
    });
  }

  onSourceMenuClose() {
    this.setState({
      anchorEl: null,
    });
  }

  onSourceClick(activeSource: string) {
    this.setState({
      anchorEl: null,
    });

    this.props.onSourceChange(activeSource);
  }

  renderSourceItem(source: Source) {
    const { activeSource } = this.props;

    return (
      <MenuItem
        key={source.prop}
        onClick={() => this.onSourceClick(source.prop)}
        selected={activeSource === source.prop}
      >
        <ListItemText primary={source.label} />
      </MenuItem>
    );
  }

  render() {
    const { sources, activeSource, sourceLabel } = this.props;
    const { anchorEl } = this.state;
    const showSourceDropdown = Boolean(anchorEl);
    const buttonLabel = this.getSourceLabel();

    return (
      <div className={css.sourceContainer}>
        <span className={css.fieldLabel}>{sourceLabel}</span>
        <div
          className={css.sourceText}
          onClick={bind(this.onSourceMenuClick, this)}
        >
          {activeSource && (
            <Fragment>
              In{' '}
              <ClickLink onClick={bind(this.onSourceMenuClick, this)}>
                {buttonLabel}
              </ClickLink>
            </Fragment>
          )}
          {!activeSource && (
            <Fragment>
              <ClickLink>Select </ClickLink>
              where you want to search...
            </Fragment>
          )}
        </div>
        <Menu
          anchorEl={anchorEl}
          onClose={bind(this.onSourceMenuClose, this)}
          open={showSourceDropdown}
        >
          <ListSubheader>Sources</ListSubheader>
          {sources.map((source) => this.renderSourceItem(source))}
        </Menu>
      </div>
    );
  }
}
